const DAY_MS = 24 * 60 * 60 * 1000;

function toDate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function today(): Date {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now;
}

export function daysBetween(fromIso: string, to: Date = today()): number {
  return Math.round((to.getTime() - toDate(fromIso).getTime()) / DAY_MS);
}

// Average gap in days between consecutive dates; null with fewer than two dates
export function averageGapDays(dates: string[]): number | null {
  if (dates.length < 2) return null;
  const sorted = [...dates].sort();
  return Math.round(daysBetween(sorted[0], toDate(sorted[sorted.length - 1])) / (sorted.length - 1));
}

export function latestDate(dates: string[]): string | null {
  return dates.length ? [...dates].sort()[dates.length - 1] : null;
}

// "4 weeks", "3 months", "10 days" — loose, plain-English spans for staff on a call
export function formatSpan(days: number): string {
  const abs = Math.abs(days);
  if (abs < 14) return `${abs} ${abs === 1 ? 'day' : 'days'}`;
  if (abs < 60) {
    const weeks = Math.round(abs / 7);
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'}`;
  }
  const months = Math.round(abs / 30.44);
  return `${months} ${months === 1 ? 'month' : 'months'}`;
}
